import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  deleteOrgTemplateLibrary,
  downloadOrgTemplateLibrary
} from 'src/redux/slices/project/endpoints'
import { isLoading } from 'src/redux/slices/project/selectors'
import { TemplateLibrary } from 'src/types/database-model'

import { Button, Grid, IconButton, Typography } from '@material-ui/core'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import DeleteIcon from '@material-ui/icons/Delete'

type LibraryProps = {
  library: TemplateLibrary
}

const Library: React.FC<LibraryProps> = ({ library }) => {
  const loading = useSelector(isLoading)
  const filename = useMemo(() => {
    const tokens = library.file_location.split('/')
    return tokens[tokens.length - 1]
  }, [library])

  const [deleteTrigger] = deleteOrgTemplateLibrary.useMutation({
    fixedCacheKey: 'deleteOrgTemplateLibrary',
  })
  const [downloadTrigger] = downloadOrgTemplateLibrary.useLazyQuery()

  const downloadLibrary = useCallback(() => {
    downloadTrigger(library.file_location)
  }, [library, downloadTrigger])

  const deleteLibrary = useCallback(() => {
    deleteTrigger({ id: library.id, file_location: library.file_location })
  }, [library, deleteTrigger])

  return (
    <Grid item container>
      <Grid container alignItems='center' spacing={2}>
        <Grid item>
          <IconButton size='small' onClick={downloadLibrary} disabled={loading}>
            <CloudDownloadIcon />
          </IconButton>
          <IconButton size='small' onClick={deleteLibrary} disabled={loading}>
            <DeleteIcon />
          </IconButton>
        </Grid>
        <Grid item xs={1}>
          <Typography variant='overline'>{library.title}</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant='caption'>{filename}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Library
